export default {
  name: 'manualNikudPaneKeyMap',
  data () {
    var keymap = {
      'A': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ש') },
      'S': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ד') },
      'F': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('כ') },
      'R': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ר') },
      'J': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ח') },
      'L': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ך') },
      'I': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ן') },
      'O': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ם') },
      'P': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('פ') },
      'U': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ו') },
      'Q': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('/') },
      '`': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter(';') },
      'shift+`': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('~') },
      '1': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('1') },
      'shift+1': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('!') },
      '2': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('2') },
      'shift+2': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('@') },
      '3': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('3') },
      'shift+3': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('#') },
      '4': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('4') },
      'shift+4': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('$') },
      '5': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('5') },
      'shift+5': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('%') },
      '6': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('6') },
      'shift+6': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('^') },
      '7': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('7') },
      'shift+7': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('&') },
      '8': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('8') },
      'shift+8': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('*') },
      '9': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('9') },
      'shift+9': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('(') },
      '0': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('0') },
      'shift+0': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter(')') },
      '-': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('-') },
      'shift+-': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('_') },
      '=': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('=') },
      'shift+=': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('+') },
      '\\': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('\\') },
      'shift+\\': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('|') },
      'w': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter("'") },
      '/': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('.') },
      '[': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter(']') }, // 'reversed' on purpose
      'B': () => { if (this.localLetterAddingMode && !(this.modalOpen())) { 
        this.addCharacter('נ') }
      },
      'D': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ג') },
      'N': () => { if (this.localLetterAddingMode && !(this.modalOpen())) { 
        this.addCharacter('מ') }
      },
      'K': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ל') },
      /*
      'right': () => { if (this.localLetterAddingMode && !(this.modalOpen())) { this.moveToPreviousLetter() } },
      'left': () => { if (this.localLetterAddingMode && !(this.modalOpen())) { this.moveToNextLetter() } },
      */
      'enter': () => {
        if (this.localLetterAddingMode && !(this.modalOpen())) {
          this.modesObj.letterAddingMode = false
        } else if (!(this.modalOpen()) && this.currentLetterNotSep) {
          this.moveToNextWord()
        }
      },
      'escape': () => { if (!(this.modalOpen())) this.modesObj.letterAddingMode = false; this.showAccountNeededPopup = false },
      'shift+A': () => { 
        if (!(this.localLetterAddingMode) && !(this.modalOpen()) && this.currentLetterNotSep) this.showApplyToAllPopup = true 
      },
      'ctrl+Q': () => {
        if (!(this.localLetterAddingMode) && !(this.modalOpen()) && this.currentLetterNotSep) {
          if (['manual', 'edited'].includes(this.localCurrentWord.choiceType)) {
            this.tryToAddToUserDictionary()
          }
        }
      },
      /*
      'delete': () => { if (!(this.modalOpen())) this.deleteCurrentLetter() },
      'backspace': () => { if (!(this.modalOpen())) this.backspaceCurrentLetter() },
      'space': () => {
        if (this.localLetterAddingMode && !(this.modalOpen())) {
          this.addCharacter(' ')
        } else if (!(this.modalOpen())) this.modesObj.letterAddingMode = true
      },
      */
      'E': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ק') },
      'T': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('א') },
      'Y': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ט') },
      'G': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ע') },
      'H': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('י') },
      ';': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ף') },
      'Z': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ז') },
      'X': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ס') },
      'C': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ב') },
      'V': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ה') },
      'M': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('צ') },
      ',': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ת') },
      '.': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('ץ') },
      ']': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('[') }, // 'reversed' on purpose
      "'": () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter(',') },
      'shift+/': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('?') },
      'shift+[': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('}') },
      'shift+]': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('{') },
      "shift+'": () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('"') },
      'shift+,': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('>') },
      'shift+.': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter('<') },
      'shift+;': () => { if (this.localLetterAddingMode && !(this.modalOpen())) this.addCharacter(':') }
    }
    /*
    const numstrings = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
    numstrings.forEach(numString => {
      keymap['numpad ' + numString] = keymap[numString]
    })
    */
    // for apply-to-all-popup (only implementing here; the "options" one's accessible only by mouse, so illogical):
    const modes = ['below', 'unedited', 'all']
    keymap['up'] = () => { if (this.showApplyToAllPopup && modes.indexOf(this.applyToAllMode) > 0) {
      this.applyToAllMode = modes[modes.indexOf(this.applyToAllMode) - 1]
    } }
    keymap['down'] = () => { if (this.showApplyToAllPopup && modes.indexOf(this.applyToAllMode) < modes.length - 1) {
      this.applyToAllMode = modes[modes.indexOf(this.applyToAllMode) + 1]
    } }
    keymap['ctrl+shift+a'] = () => { this.applyToAllMode = 'below'; this.applyToEntireText() }
    // shift-like-ctrl:
    const shiftLikeCtrl = ['Q']
    shiftLikeCtrl.forEach(keyAlone => {
      keymap['shift+' + keyAlone] = keymap['ctrl+' + keyAlone]
    })
    return {
      keymap: keymap
    }
  }
}
